import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EfIcon from '@elem/ui/ef-icon';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';

const Certification: React.FC = () => {
    const { t } = useLang('Protecting');
    const [rules, setRules] = useState<any>([]);
    const [isOpen, setIsOpen] = useState(false);
    const ruleList = [
        {
            url: 'https://websiteoss.ecoflow.com/upload/image/1747033969291/472386420926046208%201.png',
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            url: 'https://websiteoss.ecoflow.com/upload/image/1747038740227/cert3.png',
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            url: 'https://websiteoss.ecoflow.com/upload/image/1747038740227/cert3.png',
            title: t('item3_title'),
            desc: t('item3_desc'),
        },
        {
            url: 'https://websiteoss.ecoflow.com/upload/image/1747038578043/cert2.png',
            title: t('item4_title'),
            desc: t('item4_desc'),
        },
        {
            url: 'https://websiteoss.ecoflow.com/upload/image/1747039059858/cert4.png',
            title: t('item5_title'),
            desc: t('item5_desc'),
        },
        {
            url: 'https://websiteoss.ecoflow.com/upload/image/1747042471615/cert6.png',
            title: t('item6_title'),
            desc: t('item6_desc'),
        },
        {
            url: 'https://websiteoss.ecoflow.com/upload/image/1747039059858/cert4.png',
            title: t('item7_title'),
            desc: t('item7_desc'),
        },
        {
            url: 'https://websiteoss.ecoflow.com/upload/image/1747039059858/cert4.png',
            title: t('item8_title'),
            desc: t('item8_desc'),
        },
    ];

    const handleViewAll = () => {
        setIsOpen(!isOpen);
        if (!isOpen) {
            setRules(ruleList);
        } else {
            setRules(ruleList.slice(0, 4));
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_detail_page',
            list_name: t('title'),
            button_name: isOpen ? t('view_all_2') : t('view_all'),
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 768) {
                setRules(ruleList.slice(0, 4));
            } else {
                setRules(ruleList);
            }
        }
    }, []);

    return (
        <section
            className={`${styles.Protecting} GtmModuleData-section`}
            id={'stream-ultra-x-Protecting'}
            data-section-id={'stream-ultra-x-Protecting'}
            data-section-title={t('title')}
        >
            <div className="title1">{t('title')}</div>
            <div className="subtitle1">{t('desc')}</div>
            <div className="content">
                {rules.map((item: any, index: number) => (
                    <div className="cert-item" key={index}>
                        <div className="cert-icon">
                            <EfIcon pc={item.url} />
                        </div>
                        <div className="cert-title">{item.title}</div>
                        <div className="cert-desc">{item.desc}</div>
                    </div>
                ))}
            </div>
            <div className="view-m">
                <div className="view-all" onClick={handleViewAll}>
                    {!isOpen && <span>{t('view_all')}</span>}
                    {isOpen && <span>{t('view_all_2')}</span>}
                    {isOpen ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                            <path d="M5.5 12.5L10.5 7.5L15.5 12.5" stroke="#3F68E0" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                            <path d="M15.5 7.76172L10.5 12.7617L5.5 7.76172" stroke="#3F68E0" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Certification;
